import { Popover, Select } from 'antd';
import React from 'react';
import { Option } from 'antd/es/mentions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import PRZSelect from '../../Common/UI/PRZSelect';

const DownloadReports = ({
  openPopover, selectedEmails, getDownloadReportsLoading, user, loadReportsDownloadData, openPopoverChange, selectedEmailsChange,
}) => (
  <React.Fragment>
    <Popover
      placement="bottom"
      trigger="click"
      title={<div style={{ width: '280px' }}>Please provide your email address</div>}
      open={openPopover}
      onOpenChange={() => openPopoverChange()}
      content={(
        <React.Fragment>
          <div>
            <PRZSelect
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
              mode="tags"
              filterOption={false}
              value={selectedEmails}
              onChange={(event) => selectedEmailsChange(event)}
              placeholder="Enter email address"
              disabled={getDownloadReportsLoading}
              maxTagCount="responsive"
              style={{
                width: '300px',
                height: 'auto !important',
              }}
            >
              {selectedEmails.length > 0 ? (
                selectedEmails.map((item) => (
                  <Option key={item} value={item}>
                    {item}
                  </Option>
                ))
              ) : (
                <Option key={user?.email} value={user?.email}>
                  {user?.email}
                </Option>
              )}
            </PRZSelect>
          </div>
          <div style={{
            marginTop: '10px',
            display: 'flex',
            gap: '10px',
          }}
          >
            <H3Button
              text="Send"
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              onClick={() => loadReportsDownloadData('send_email', true)}
              customClass="email-submit"
              isLoading={getDownloadReportsLoading}
              disabled={selectedEmails.length === 0 || getDownloadReportsLoading}
              style={{
                width: '60px',
                height: '23px',
                borderRadius: '5px',
                  padding: '0px',
              }}
            >
              Send
              {' '}

            </H3Button>

            {/* <H3Button
              text="Download"
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              onClick={() => loadReportsDownloadData('download', true)}
              customClass="email-submit"
              isLoading={getDownloadReportsLoading}
              disabled={getDownloadReportsLoading}
              style={{
                width: '90px',
                height: '27px',
                borderRadius: '5px',
                padding: '14px',
              }}
            >
              Download

            </H3Button> */}

          </div>

        </React.Fragment>
      )}
    >
      <div
        className={`report-header__action-btn
         ${getDownloadReportsLoading ? 'report-header__action-btn-disabled' : ''}
         `}
      >
        <H3Text
          text={(
            <FontAwesomeIcon icon={faDownload} />
          )}
          className="action-button"
        />
      </div>

    </Popover>
  </React.Fragment>
);

DownloadReports.propTypes = {
  openPopover: PropTypes.bool,
  selectedEmails: PropTypes.array,
  getDownloadReportsLoading: PropTypes.bool,
  user: PropTypes.object,
  loadReportsDownloadData: PropTypes.func,
  openPopoverChange: PropTypes.func,
  selectedEmailsChange: PropTypes.func,

};

export default DownloadReports;
